(() => {
  const storageKey = 'otb:wishlist-products';

  const readWishlist = () => {
    try {
      const value = JSON.parse(localStorage.getItem(storageKey) || '[]');
      return new Set(Array.isArray(value) ? value.map(String) : []);
    } catch {
      return new Set();
    }
  };

  const writeWishlist = (wishlist) => {
    try {
      localStorage.setItem(storageKey, JSON.stringify([...wishlist]));
    } catch {
      // The button still works for the current view when storage is unavailable.
    }
  };

  let wishlist = readWishlist();

  const updateButton = (button) => {
    const selected = wishlist.has(String(button.dataset.productId));
    button.setAttribute('aria-pressed', String(selected));
    button.setAttribute('aria-label', selected ? button.dataset.removeLabel : button.dataset.addLabel);
  };

  const updateButtons = (root = document) => {
    if (root.matches?.('[data-otb-wishlist-button]')) updateButton(root);
    root.querySelectorAll?.('[data-otb-wishlist-button]').forEach(updateButton);
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest?.('[data-otb-wishlist-button]');
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    const productId = String(button.dataset.productId);
    if (wishlist.has(productId)) wishlist.delete(productId);
    else wishlist.add(productId);

    writeWishlist(wishlist);
    document.querySelectorAll(`[data-otb-wishlist-button][data-product-id="${CSS.escape(productId)}"]`).forEach(updateButton);
  });

  const observer = new MutationObserver((records) => {
    records.forEach((record) => record.addedNodes.forEach((node) => {
      if (node instanceof Element) updateButtons(node);
    }));
  });

  // Save for later writes the same storage key from the cart page. Re-read
  // rather than trust the in-memory copy, or a product saved out of the cart
  // shows an empty heart in the recommendations directly below it.
  document.addEventListener('otb:wishlist-updated', () => {
    wishlist = readWishlist();
    updateButtons();
  });

  const init = () => {
    updateButtons();
    observer.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
